import {ApolloError} from "@apollo/client";
import {TFunction} from "i18next";

/**
 * Formats tenant creation errors with user-friendly messages
 * for the simple hierarchy creation flow.
 *
 * @param error - The error from tenant creation (ApolloError or generic Error)
 * @param tenantName - The name of the tenant being created
 * @param t - Translation function for i18n
 * @returns A new Error with a user-friendly message
 */
export const formatTenantCreationError = (
  error: ApolloError | Error,
  tenantName: string,
  t: TFunction
): Error => {
  if (error instanceof ApolloError) {
    if (error.networkError) {
      return new Error(
        t("create-operational-hierarchy.errors.tenant.network-error-detail")
      );
    }

    if (error.graphQLErrors && error.graphQLErrors.length > 0) {
      const graphQLError = error.graphQLErrors[0];
      const errorMessage = graphQLError?.message || error.message;
      return new Error(
        t("create-operational-hierarchy.errors.tenant.graphql-error-detail", {
          errorMessage
        })
      );
    }
  }

  return new Error(
    t("create-operational-hierarchy.errors.tenant.creation-failed-detail", {
      tenantName
    })
  );
};
